function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5.79 10.71l-1.84 1.84a.996.996 0 01-1.41 0L12 12l-2.54 2.54a.996.996 0 01-1.41 0L6.21 12.7a.996.996 0 010-1.41l1.84-1.84a.996.996 0 011.41 0L12 12l2.54-2.54a.996.996 0 011.41 0l1.84 1.84c.39.38.39 1.02 0 1.41z"
})));